import { useQuery, type UseQueryOptions } from 'react-query';

import { zackeyCheck } from '../zackey-session.2';
import type { ZackeyCheck_zackey_check, ZackeyCheckVariables } from '../zackey-session_types.2';

export const ZACKEY_CHECK_QUERY_KEY = 'zackeyCheck';

export interface UseZackeyCheckQueryParams {
  productId: string;
}

export const useZackeyCheckQuery = (
  params: UseZackeyCheckQueryParams,
  options?: Omit<UseQueryOptions<ZackeyCheck_zackey_check, Error, ZackeyCheck_zackey_check>, 'queryKey' | 'queryFn'>,
) => {
  const variables: ZackeyCheckVariables = {
    product_id: params.productId,
  };

  return useQuery<ZackeyCheck_zackey_check, Error>(
    [ZACKEY_CHECK_QUERY_KEY, variables],
    async () => {
      const { data } = await zackeyCheck(variables);
      return data.zackey_check;
    },
    options,
  );
};
